/**
 * How often a `typing: true` ping may be sent while the user keeps typing.
 *
 * Only the trailing `typing: false` was ever debounced; the `true` ping fired on EVERY keystroke — about
 * 240 mutations for a 40-word message, each carrying a session lookup, an upstream fetch to genesis and a
 * Redis write. genesis keeps presence on a TTL, so one ping per interval is enough for the peer to keep
 * seeing the indicator; the interval sits comfortably inside that TTL so it cannot flicker.
 */
export const TYPING_PING_INTERVAL_MS = 2000;

/** Sentinel for "not currently pinging", so the next keystroke always sends. */
export const NO_TYPING_PING = 0;

/**
 * Whether a `typing: true` ping is due.
 *
 * `lastPingAt` is {@link NO_TYPING_PING} when the user was not typing, which must always ping so the peer
 * sees the indicator without waiting out an interval.
 */
export function shouldPingTyping(now: number, lastPingAt: number): boolean {
  if (lastPingAt === NO_TYPING_PING) return true;
  return now - lastPingAt >= TYPING_PING_INTERVAL_MS;
}
